<div class="style-step-shell">
  <section class="style-stage">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p class="style-step-shell__eyebrow hidden md:block">Stile di arredo</p>
        <h2 class="font-display mt-2 text-3xl text-gray-900 md:text-4xl">
          @switch (view()) {
            @case ('remove') {
              Cosa vuoi rimuovere?
            }
            @case ('furnish') {
              Scegli lo stile di arredo
            }
            @default {
              Vuoi svuotare la stanza o arredarla?
            }
          }
        </h2>
        <p
          class="mt-3 hidden max-w-3xl text-sm leading-6 text-gray-500 md:block"
        >
          L'AI trasformerà {{ filesCount() }} foto in immagini pronte da
          pubblicare online.
        </p>
      </div>

      <div class="hidden items-center gap-3 md:flex">
        <button type="button" class="btn-outline-gray" (click)="back.emit()">
          Torna alle foto
        </button>
        @if (view() !== 'choose') {
          <button
            type="button"
            class="btn-solid-blue-casa-doc"
            [disabled]="!canProceed()"
            (click)="proceed.emit()"
          >
            Continua
          </button>
        }
      </div>
      <button
        type="button"
        class="btn-outline-gray md:hidden"
        (click)="back.emit()"
      >
        Torna alle foto
      </button>
    </div>

    @if (view() === 'choose') {
      <div class="mode-grid">
        <button type="button" class="mode-card" (click)="onChooseRemove()">
          <div class="mode-card__preview">
            <img
              class="mode-card__image"
              src="/interior-styles/rimuovi-arredi.jpg"
              alt="Rimuovi gli elementi dalla stanza"
              loading="lazy"
            />
            <div class="mode-card__overlay">
              <span class="mode-card__label"
                >Rimuovi gli elementi dalla stanza</span
              >
            </div>
          </div>
        </button>

        <button type="button" class="mode-card" (click)="onChooseFurnish()">
          <div class="mode-card__preview">
            <img
              class="mode-card__image"
              src="/interior-styles/contemporaneo.jpg"
              alt="Arreda la stanza"
              loading="lazy"
            />
            <div class="mode-card__overlay">
              <span class="mode-card__label">Arreda</span>
            </div>
          </div>
        </button>
      </div>
    }

    @if (view() === 'remove') {
      <button type="button" class="back-chip" (click)="onBackToChoose()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          width="16"
          height="16"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.79 5.23a.75.75 0 0 1 0 1.06L9.06 10l3.73 3.71a.75.75 0 1 1-1.06 1.06l-4.25-4.24a.75.75 0 0 1 0-1.06l4.25-4.24a.75.75 0 0 1 1.06 0Z"
            clip-rule="evenodd"
          />
        </svg>
        Cambia
      </button>

      <div class="removal-options removal-options--standalone">
        <label class="toggle-row">
          <input
            type="checkbox"
            class="h-4 w-4 accent-black"
            [checked]="removePersonalEffects()"
            (change)="onToggleRemovePersonalEffects($event)"
          />
          <span>
            <strong>Rimuovi effetti personali</strong>
            <small
              >Rimuove foto, quadri, vestiti, documenti e oggetti in disordine,
              lasciando mobili ed arredi.</small
            >
          </span>
        </label>

        <label class="toggle-row">
          <input
            type="checkbox"
            class="h-4 w-4 accent-black"
            [checked]="removeFurniture()"
            (change)="onToggleRemoveFurniture($event)"
          />
          <span>
            <strong>Rimuovi arredi</strong>
            <small
              >Rimuove mobili principali come letti, divani, tavoli, sedie e
              armadi.</small
            >
          </span>
        </label>
      </div>
    }

    @if (view() === 'furnish') {
      <button type="button" class="back-chip" (click)="onBackToChoose()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          width="16"
          height="16"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.79 5.23a.75.75 0 0 1 0 1.06L9.06 10l3.73 3.71a.75.75 0 1 1-1.06 1.06l-4.25-4.24a.75.75 0 0 1 0-1.06l4.25-4.24a.75.75 0 0 1 1.06 0Z"
            clip-rule="evenodd"
          />
        </svg>
        Cambia
      </button>

      <div class="style-grid">
        @for (style of furnishStyles(); track style.value) {
          <button
            type="button"
            class="style-card"
            [class.style-card--selected]="furnitureStyle() === style.value"
            (click)="onSelectStyle(style.value)"
          >
            <div class="style-card__preview">
              <img
                class="style-card__image"
                [src]="style.imageSrc"
                [alt]="style.label"
                loading="lazy"
              />
              <div class="style-card__overlay">
                <span class="style-card__label">{{ style.label }}</span>
                @if (furnitureStyle() === style.value) {
                  <span
                    class="style-card__selected-mark"
                    aria-label="Selezionato"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                      width="10"
                      height="10"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </span>
                }
              </div>
            </div>
          </button>
        }
      </div>
    }

    @if (view() !== 'choose') {
      <button
        type="button"
        class="mobile-primary-cta w-full btn-solid-blue-casa-doc md:hidden"
        [disabled]="!canProceed()"
        (click)="proceed.emit()"
      >
        Continua
      </button>
    }
  </section>
</div>
